import { SectionContainer } from "../molecules/section-container";
import { useNavigate } from "react-router-dom";
import { Button } from "../atoms/button";

export const Instructions = () => {
  const navigate = useNavigate();

  return (
    <SectionContainer title="Perle Collect - How to">
      <h2 className="font-semibold mb-6">🎧 How to Contribute Your Sounds</h2>
      <ol className="list-decimal list-inside space-y-4 text-left font-medium">
        <li>
          <strong>Upload Your Clips:</strong> Up to 5 original WAV recordings
          (44.1 kHz/16-bit), 5–10 seconds each. No filters or edits.
        </li>
        <li>
          <strong>Pick a Category:</strong>
          <ul className="list-disc list-inside mt-2 ml-4 space-y-1">
            <li>
              <strong>Appliance Alarm:</strong> microwave beeps, fire-alarm
              chirps
            </li>
            <li>
              <strong>Cat Sounds:</strong> meows or purrs
            </li>
            <li>
              <strong>Clap:</strong> single, double, or triple hand clap
            </li>
            <li>
              <strong>Dog Sounds:</strong> growls or howls (tag barks
              separately)
            </li>
            <li>
              <strong>Doorbell:</strong> mechanical chimes or buzzers
            </li>
            <li>
              <strong>Hairdryer:</strong> motor hum of a hairdryer
            </li>
            <li>
              <strong>Kettle Boiling:</strong> whistling or bubbling kettle
            </li>
            <li>
              <strong>Knock:</strong> knocking on doors or other surfaces
            </li>
            <li>
              <strong>Siren:</strong> police, ambulance, or other emergency
              sirens
            </li>
            <li>
              <strong>Water Running:</strong> faucet, tap, or shower flow
            </li>
            <li>
              <strong>Yell:</strong> human shout or scream
            </li>
          </ul>
        </li>
        <li>
          <strong>Add Metadata:</strong> Fill in age range, room type, mic
          distance, intended use, etc. (we parse these automatically). Please
          make sure the metadata is <b>written in English</b>.
        </li>
        <li>
          <strong>Tag Extra Sounds:</strong> In "Present Sounds," list any other
          clear noises you hear (e.g. a siren clip with a beep → tag "Appliance
          Alarm").
        </li>
        <li>
          <strong>Review &amp; Submit:</strong> Double-check files and fields,
          then click <em>Submit</em>. (No autosave—make sure everything's set.)
        </li>
      </ol>
      <div className="mt-6 mb-4">
        <Button
          type="primary"
          text="Go to task selection"
          onClick={() => navigate("/")}
        />
      </div>
    </SectionContainer>
  );
};
